import { List, Plus } from "@untitledui/icons";
import { EmptyState } from "@/components/application/empty-state/empty-state";
import { SlideoutMenu } from "@/components/application/slideout-menus/slideout-menu";
import { Button } from "@/components/base/buttons/button";

interface RulesListEmptyDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreate: () => void;
  overlayClassName?: string;
}

export function RulesListEmptyDrawer({ open, onOpenChange, onCreate, overlayClassName }: RulesListEmptyDrawerProps) {
  return (
    <SlideoutMenu isOpen={open} onOpenChange={onOpenChange} isDismissable className={overlayClassName}>
      <SlideoutMenu.Header onClose={() => onOpenChange(false)}>
        <h2 className="text-lg font-semibold text-primary">Sample Auto-Approval Rules</h2>
      </SlideoutMenu.Header>

      <SlideoutMenu.Content className="items-center justify-center">
        <EmptyState size="sm">
          <EmptyState.FeaturedIcon icon={List} color="gray" />
          <EmptyState.Content>
            <EmptyState.Title>No rules yet</EmptyState.Title>
            <EmptyState.Description>
              Create a rule to automatically approve or ignore sample requests based on creator signals.
            </EmptyState.Description>
          </EmptyState.Content>
          <EmptyState.Footer>
            <Button color="primary" iconLeading={Plus} onClick={onCreate}>
              New Rule
            </Button>
          </EmptyState.Footer>
        </EmptyState>
      </SlideoutMenu.Content>
    </SlideoutMenu>
  );
}
